export { SwitchVertical as default } from './SwitchVertical';
